import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Link} from "react-router-dom";
import { isEmail } from 'validator';
import {Checkbox} from "@blueprintjs/core";

// Actions
import { createUser, cleanUsers } from "../../../actions/users";

class NewUser extends Component {
    constructor(props) {
        super(props);

        this.state = {
            name: '',
            surname: '',
            email: '',
            password: '',
            verifyPassword: '',
            sendEmail: false,
            validName: false,
            validEmail: false,
            validPassword: false,
            passwordMatches: false,
            canSubmit: false,
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        return this.state.canSubmit !== nextState.canSubmit;
    }

    componentWillUnmount() {
        this.props.cleanUsers();
    }

    onChangeInput = (inputName, inputValue) => {
        this.setState({
            [inputName]: inputValue,
            ...(inputName === 'name') ? { validName: inputValue !== '' } : {},
            ...(inputName === 'email') ? { validEmail: isEmail(inputValue) } : {},
            ...(inputName === 'password') ? { validPassword: inputValue.length > 5 } : {},
            ...(inputName === 'password') ? { passwordMatches: inputValue === this.state.verifyPassword } : {},
            ...(inputName === 'verifyPassword') ? { passwordMatches: inputValue === this.state.password } : {}
        }, this.validateUser);
    };

    validateUser = () => {
        const canSubmit =
            this.state.validName &&
            this.state.validEmail &&
            this.state.validPassword &&
            this.state.passwordMatches;

        this.setState({
            canSubmit
        });
    };

    handleCreateClick = () => {
        this.props.createUser({
            name: this.state.name,
            ...(this.state.surname !== '') ? { surname: this.state.surname } : {},
            email: this.state.email,
            password: this.state.password,
            verifyPassword: this.state.verifyPassword,
            sendEmail: this.state.sendEmail
        });
        this.props.history.push('/usuarios');
    };

    render() {
        const {
            canSubmit,
            sendEmail
        } = this.state;

        return (
            <div id="page-wrapper" className="gray-bg">
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col d-flex align-items-center">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                Configuración
                            </li>
                            <li className="breadcrumb-item">
                                <Link to="/usuarios">Usuarios</Link>
                            </li>
                            <li className="breadcrumb-item active">
                                <strong>Nuevo Usuario</strong>
                            </li>
                        </ol>
                    </div>
                    <div className="col d-flex align-items-center justify-content-end">
                        <div className="title-action">
                            <button
                                className="btn btn-cancel"
                                onClick={ () => this.props.history.push('/usuarios') }
                            >Cancelar
                            </button>
                            <button
                                className="btn btn-primary"
                                onClick={ () => this.handleCreateClick() }
                                disabled={!canSubmit}
                            >Crear
                            </button>
                        </div>
                    </div>
                </div>
                <div className="wrapper wrapper-content">
                    <div className="row">
                        <div className="col">
                            <div className="ibox">
                                <div className="ibox-content">
                                    <div className="row">
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>Nombre *</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    onChange={ (event) => this.onChangeInput('name', event.target.value) }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>Apellidos</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    onChange={ (event) => this.onChangeInput('surname', event.target.value) }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-6">
                                            <div className="form-group">
                                                <label>Email *</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    onChange={ (event) => this.onChangeInput('email', event.target.value) }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>Contraseña *</label>
                                                <input
                                                    className="form-control"
                                                    type="password"
                                                    onChange={ (event) => this.onChangeInput('password', event.target.value) }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>Vuelve a introducir la contraseña *</label>
                                                <input
                                                    className="form-control"
                                                    type="password"
                                                    onChange={ (event) => this.onChangeInput('verifyPassword', event.target.value) }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <div>
                                                <Checkbox
                                                    checked={sendEmail}
                                                    onChange={(event) => this.onChangeInput('sendEmail', event.target.checked)}
                                                    label="Enviar email al usuario"
                                                    inline={true}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        createUser: (user) => dispatch(createUser(user)),
        cleanUsers: () => dispatch(cleanUsers())
    };
};

export default connect(null, mapDispatchToProps)(NewUser);



// WEBPACK FOOTER //
// ./src/containers/configuration/users/NewUser.js